/**
 * @generated SignedSource<<0d557810954b30ac0c428bc5b83a60b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteInsightShareInput = {
  id: string;
  insightId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteInsightShareMutation$variables = {
  input: DeleteInsightShareInput;
};
export type deleteInsightShareMutation$data = {
  readonly deleteInsightShare: {
    readonly deletedInsightShareId: string | null;
  } | null;
};
export type deleteInsightShareMutation = {
  variables: deleteInsightShareMutation$variables;
  response: deleteInsightShareMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteInsightSharePayload",
    "kind": "LinkedField",
    "name": "deleteInsightShare",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedInsightShareId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteInsightShareMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteInsightShareMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0e070fbe40488b5a4d00c8b1f99156f6",
    "id": null,
    "metadata": {},
    "name": "deleteInsightShareMutation",
    "operationKind": "mutation",
    "text": "mutation deleteInsightShareMutation(\n  $input: DeleteInsightShareInput!\n) {\n  deleteInsightShare(input: $input) {\n    deletedInsightShareId\n  }\n}\n"
  }
};
})();

(node as any).hash = "8bd0d439870b4f4d5364416f5238e64c";

export default node;
